<template>
  <div class="grid gap-1">
    <div
      v-html="renderedMarkdown(value.details)"
      class="inherit-body without-scrollbar grid max-h-[190px] gap-1 overflow-y-auto text-[14px] font-medium"
      :class="[mode === 'dark' ? 'inherit-dark-body' : '']"
    ></div>
    <div v-if="value.power_search_id" class="mt-[2px]">
      <!-- <RouterLink
        :to="{
          name: `${
            value.record_type === 'L' ? 'listing-details' : 'mail-details'
          }`,
          params: {
            id: value.power_search_id,
          },
        }"
        target="_blank"
        class="flex gap-2 text-[12px] font-semibold capitalize leading-none text-primary-100 underline"
        >View</RouterLink
      > -->
      <RouterLink
        :to="{
          name: 'listing-details',
          params: {
            id: value.power_search_id,
          },
        }"
        target="_blank"
        class="flex gap-2 text-[12px] font-semibold capitalize leading-none text-primary-100 underline"
        >View</RouterLink
      >
    </div>
  </div>
</template>

<script>
import { marked } from "marked";

export default {
  name: "FallbackDetails",
  props: {
    mode: String,
    value: {
      type: Object,
      default: {
        details: "",
        power_search_id: "",
        record_type: "",
      },
    },
  },
  methods: {
    renderedMarkdown(body) {
      const cleanBody = body
        .replaceAll("```markdown", "")
        .replaceAll("```", "");
      return marked(cleanBody);
    },
  },
};
</script>
